import axios from "../../axios";

const urlPage = "/pages";
const urlPageDeleteMultiple = "/pages/delete-multiple";

const state = {
  pages: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
  listAll: [],
};

const actions = {
  /**
   * getListPages
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListPages({ commit }, query) {
    const response = await axios.get(
      `${urlPage}?${new URLSearchParams(query)}`,
    );
    if (response.status === 200) {
      commit("SET_LIST_PAGES", response.data.data);
    }
    return response.data ?? {};
  },

  async getAllPages({ commit }, query) {
    const response = await axios.get(
      `${urlPage}/all?${new URLSearchParams(query)}`,
    );
    if (response.status === 200) {
      commit("SET_ALL_PAGES", response.data.data);
    }
    return response.data ?? {};
  },

  /**
   * createPage
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async createPage({ commit }, payload) {
    return await axios.post(urlPage, payload);
  },

  /**
   * updatePage
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async updatePage({ commit }, { id, payload }) {
    return await axios.put(`${urlPage}/${id}`, payload);
  },

  /**
   * deletePage
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async deletePage({ commit }, id) {
    return await axios.delete(`${urlPage}/${id}`);
  },

  async deleteItemList({ commit }, id) {
    commit("DELETE_ITEM_LIST", id);
  },

  // eslint-disable-next-line no-unused-vars
  async changeOrder({ commit }, payload) {
    const response = await axios.post(urlPage + "/change-order", payload);
    return response;
  },

  /**
   * deleteMultiple
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async deleteMultiple({ commit }, payload) {
    return await axios.post(urlPageDeleteMultiple, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_PAGES(state, data) {
    if (data) {
      let map = {},
        node,
        roots = [],
        i;

      for (i = 0; i < data.items.length; i += 1) {
        map[data.items[i].id] = i; // initialize the map
        data.items[i].children = []; // initialize the children
        data.items[i].oldStatus = data.items[i].status;
      }

      for (i = 0; i < data.items.length; i += 1) {
        node = data.items[i];
        if (node.parent_id) {
          // if you have dangling branches check that map[node.parent_id] exists
          if (data.items[map[node.parent_id]]) {
            data.items[map[node.parent_id]].children.push(node);
            data.items[i].isRemove = true;
          }
        } else {
          roots.push(node);
        }
      }
      state.pages = data.items;
      state.pagination = data.pagination;
    }
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },

  SET_ALL_PAGES(state, data) {
    state.listAll = data;
  },

  DELETE_ITEM_LIST(state, id) {
    const index = state.listAll.findIndex((u) => u.id === id);

    if (index >= 0) {
      state.listAll.splice(index, 1);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
